import { useHeaderStore } from '@/store/headerStore';
import { useUserStore } from '@/store/userStore';
import { useEffect } from 'react';
import { matchPath, useLocation, useNavigate, useRoutes } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { routesWithMeta } from './routes';

export const AppRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const setHeader = useHeaderStore((state) => state.setHeader);
  const user = useUserStore((state) => state.user);
  const hostname = window.location.hostname;

  useEffect(() => {
    if (
      location.pathname === '/' &&
      hostname !== 'www.shelflix.com.br' &&
      hostname !== 'shelflix.com.br' &&
      hostname !== 'hml.shelflix.com.br' &&
      hostname !== 'localhost'
    ) {
      // Preserve query params when redirecting to /pos
      const queryString = location.search;
      navigate(`/pos${queryString}`, { replace: true });
    }

    const matchedRoute = routesWithMeta.find((route) => matchPath(route.path, location.pathname));

    if (matchedRoute) {
      const match = matchPath(matchedRoute.path, location.pathname);

      const breadcrumb =
        typeof matchedRoute.meta.breadcrumb === 'function'
          ? matchedRoute.meta.breadcrumb(match?.params || {}, location.state)
          : matchedRoute.meta.breadcrumb;

      const title =
        typeof matchedRoute.meta.title === 'function' ? matchedRoute.meta.title(user) : matchedRoute.meta.title;

      setHeader({
        title,
        breadcrumb,
        backButton: matchedRoute.meta.backButton,
        button: matchedRoute.meta.getButton?.map((getButton) => getButton(navigate)),
      });
    }
  }, [location.pathname, user, hostname]);

  const routes = routesWithMeta.map((r) => ({
    path: r.path,
    element: (
      <ProtectedRoute
        requiredAuth={r.requiresAuth}
        requiredScopes={r.requiresScopes}
        requiredMaster={r.requiresMaster}
        redirectToLogin={r.redirectToLogin}
      >
        {r.element}
      </ProtectedRoute>
    ),
  }));

  return useRoutes(routes);
};
